import { useNavigate } from "react-router-dom";
import CustomerTopbar from "../../features/manageCustomers/topbar";
import CustomerList from "../../features/manageCustomers/customerList";

const ManageCustomers = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>User Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - User Management
        </p>
      </div>

      <div className="cards">
        <CustomerTopbar />
        <CustomerList />
      </div>
    </>
  );
};

export default ManageCustomers;
